import { EntityType } from '../../../@types/entityTypes';
import instanceQuery from '../../queries/product/SubMaterialQuery.graphql';
import workspaceQuery from '../../queries/product/SubMaterialWorkspaceQuery.graphql';
import defaultQuery from '../../queries/product/SubMaterialDefault.graphql';
import mutationQuery from '../../mutations/product/SubMaterialMutation.graphql';
import fragment from '../../fragments/product/SubMaterialFragment.graphql';

const SubMaterial: EntityType = {
  type: 'SubMaterial',
  title: 'Sub Material',
  formTitle: 'Sub Material',
  formUrl: '/Products/EPR/SubMaterial/Details/',
  workspaceUrl: '/Products/EPR/SubMaterial/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment: fragment,
  dropdown: {
    query: workspaceQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  screenReference: 'SUB_MATERIAL',
};

export default SubMaterial;
